import { useEffect } from 'react';
import useAuth from '../../../hooks/useAuth';
import axios from '../../../axios-default';
import { useDispatch } from 'react-redux';
import { SET_ENABLE_ORDER_DIFFERENT_RETAINER } from '../../../store/DiffRetainers/actionType';

const useGetEnableRetainerRequest = (isFetchRetainerRelatedData = false) => {
    const auth = useAuth();
    const dispatch = useDispatch();

    useEffect(() => {
        const user = auth.user;
        const targetDistrGroupId = user.distr_group_id || user.doctor_distr_group_id;
        const role = user?.role || '';
        if (!auth.user || !targetDistrGroupId || role !== 'DR' || !isFetchRetainerRelatedData) return;
        const getEnableRetainerRequest = async () => {
            const res = await axios.get(`case/retainer_request/enable/${targetDistrGroupId}`);
            if (res.data && res.status === 200 && res.data.enableRetainerRequest) {
                dispatch({ type: SET_ENABLE_ORDER_DIFFERENT_RETAINER, payload: res.data.enableRetainerRequest });
            }
        };
        if (targetDistrGroupId) {
            getEnableRetainerRequest();
        }
    }, [auth.user, isFetchRetainerRelatedData]);
};

export default useGetEnableRetainerRequest;
